import { Box, Button, Card, Icon, Spinner, Text } from '@nimbus-ds/components';
import { CheckCircleIcon } from '@nimbus-ds/icons';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

interface DomainSuggestionCardProps {
  domain: string;
  price: string;
  onClick?: () => void;
  onBuyDomain?: (domain: string) => Promise<void>;
  disabled?: boolean;
  isLoading?: boolean;
}

export function DomainSuggestionCard({
  domain,
  price,
  onClick,
  onBuyDomain,
  disabled = false,
  isLoading = false,
}: Readonly<DomainSuggestionCardProps>) {
  const t = useTranslationConfigurations(
    'domains.landing.addDomainModal.searchNewDomain',
  );

  const handleBuyClick = () => {
    if (disabled) return;

    if (onClick) {
      onClick();
      return;
    }

    if (onBuyDomain) {
      onBuyDomain(domain);
    }
  };

  return (
    <Box
      borderColor="primary-interactive"
      borderStyle="solid"
      borderWidth="1"
      borderRadius="2"
    >
      <Card>
        <Card.Body>
          <Box display="flex" flexDirection="column">
            <Box display="flex" alignItems="center" gap="1">
              <Icon
                source={<CheckCircleIcon size={12} />}
                color="success-textLow"
              />
              <Text fontSize="base" color="success-textLow">
                {t('domainAvailable')}
              </Text>
            </Box>
            <Box marginTop="2">
              <Text fontSize="highlight" color="neutral-textHigh">
                {domain}
              </Text>
              <Text fontSize="base" color="neutral-textLow">
                {price}
              </Text>
            </Box>
            <Box marginTop="2">
              <Button appearance="primary" fullWidth onClick={handleBuyClick}>
                {isLoading ? (
                  <Spinner color="currentColor" size="small" />
                ) : null}
                {t('buyButton')}
              </Button>
            </Box>
          </Box>
        </Card.Body>
      </Card>
    </Box>
  );
}
